import { baseGrtURL } from '../../httpService/API';
import { hMacAjax } from '../../httpService';

const reqUrl = `${baseGrtURL}/api/grt-ai`;

export const url = {
    parseFile: `${reqUrl}/files`, //解析文件
    fileStatus: `${reqUrl}/files/status` //解析文件
};
//入库 + 解析文件
export function handleParseFile(data) {
    return hMacAjax.post(url.parseFile, data);
}
// -获取文件解析状态
export function handleGetFileStatus(data) {
    return hMacAjax.post(url.fileStatus, data);
}
